import { Service } from "puzzle";
import * as _ from "lodash";
import { ERROR_LOCALE, RESPONSE } from "./Types";
import { checkAndConvertToStaticMarkup } from "../Util";

class ErrorHandler extends Service {
  private static _instance: any;

  public static get Instance() {
    return this._instance || (this._instance = new this());
  }

  constructor() {
    super();
    this.registerServiceToDispatcher();
  }

  warningCodes: string[] = [
    'COMPLETE_REST_VALID_ACTION_DEMOTEIMPOSS',
    'DOWNLOAD_REST_ERR_PRT_DOWNLOAD',
    'DOWNLOAD_REST_ERR_PYL_DOWNLOAD',
    'DOWNLOAD_REST_ERR_SUB_DOWNLOAD',
    'EDITOR_URLS_REST_ERR_ACTION_CONTAINSNONPARSABLE',
    'EDITOR_URLS_REST_ERR_ACTION_SUBEDINVALSEL',
    'QUOTE_REVIEW_REST_ERR_QUOT_NOTREADY',
    'REOPEN_DELIVER_REST_VALID_ACTION_FORBIDDEN',
    'REOPEN_OPEN_REST_ERR_ACTION_CONTAINSNONPARSABLE',
    'REOPEN_OPEN_REST_ERR_ACTION_SUBEDINVALSEL',
    'REOPEN_REST_ERR_ACTION_IMPOSSIB',
    'SUPPLIER_COMPLETE_REST_ERR_ACTION_PROMALREADCOMPL',
    'SUPPLIER_COMPLETE_REST_ERR_ACTION_PROMNOTUPLOADED'
  ];

  toasterWarningCodes: string[] = [
    'DOWNLOAD_REST_ERR_ACTION_IMPOSSIB',
    'QUOTE_DOWNLOAD_REST_VALID_REQ_QUOTEMPTY'
  ]

  infoCodes: string[] = [];


  /**
   * Initialize ErrorHandler service
   */
  initialize = () => {
    //don't delete method, must be presented for instancing purpose
  }

  /**
   * Prepare error strings for warning dialog
   */
  prepareErrorStrings = (responseObj: RESPONSE, endpointPrefix = '') => {
    let error = responseObj.data.errors[0];
    let status = responseObj.status;
    let parsedErrorCode = endpointPrefix + _.replace(error.errorCode, /\./g, '_');
    let localeObj = (this.translate(parsedErrorCode) as any as ERROR_LOCALE);
    let errorStrings;
    if (_.isObject(localeObj)) {
      let localeTitle = checkAndConvertToStaticMarkup(localeObj.title);
      let localeText = checkAndConvertToStaticMarkup(localeObj.text);
      errorStrings = {
        title: localeTitle,
        text: localeText,
        close: localeObj.close ? localeObj.close : this.translate('close')
      }
    } else {
      let statusKey = `statusTitle.${status.toString()}`;
      let title = this.translate(statusKey);
      if (title === statusKey || error.message) {
        title = error.message;
      }

      let text = error.description ? error.description : error.message;
      errorStrings = {
        title: title,
        text: text,
        close: this.translate('close'),
      }
    }
    let warningType = 'error';
    let isToaster = false;
    if (this.warningCodes.includes(parsedErrorCode)) {
      warningType = 'warning';
    } else if (this.infoCodes.includes(parsedErrorCode)) {
      warningType = 'info';
    } else if (this.toasterWarningCodes.includes(parsedErrorCode)) {
      warningType = 'warning';
      isToaster = true;
    }
    errorStrings = Object.assign(errorStrings, {
      warningType: warningType,
      warningClass: `${warningType} footer-centered sm`,
      isToaster: isToaster
    });
    return errorStrings;
  }
}

const ErrorHandlerManager: any = ErrorHandler.Instance;
export default ErrorHandlerManager;
